export default __webpack_public_path__ + "static/media/miniuser.01d36453.svg";